//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "filters",
  props: ["value"],
  components: {},
  mounted: function() {},
  data: () => ({
    insignia: null,
    chain: null,
    retailer: null,
    retailerList: [
      {
        id: 1,
        name: "Sonae"
        // insignia: ['Continente', 'Worten']
      },
      {
        id: 2,
        name: "Jerónimo Martins"
        // insignia: ['Pingo Doce', 'Lidosol']
      },
      {
        id: 3,
        name: "Auchan"
        // insignia: ['Auchan', 'Box', 'MyAuchan']
      }
    ],
    insigniaList: {
      1: [
        {
          id: 1,
          name: "Continente"
        },
        {
          id: 2,
          name: "Worten"
        }
      ],
      2: [
        {
          id: 3,
          name: "Pingo Doce"
        },
        {
          id: 4,
          name: "Lidosol"
        }
      ],
      3: [
        {
          id: 5,
          name: "Auchan"
        },
        {
          id: 6,
          name: "Box"
        },
        {
          id: 7,
          name: "MyAuchan"
        }
      ]
    },
    chainList: []
  }),
  methods: {
    updateData() {
      this.$emit("value", this.value);
    }
  }
};
